<!--
 * @Description: 客户信息查询
--> 
<template>
  <div class="info-query">
    <van-nav-bar
      left-text="返回"
      :title="$route.meta.title"
      @click-left="$comm.onClickLeft"
      left-arrow
      fixed
      >
      <template #left>
        <span class="iconfont iconshang comm-rotate-270"></span>
        <span class="comm-return">返回</span>
      </template>
    </van-nav-bar>
    <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>
    <van-tabs color="#1677FF" v-model="active" @change="onChange" sticky>
      <van-tab v-for="(tab, i) in tabs" :key="i" :title="tab.title">
        <div class="tab-content">
          <div class="comm-search-bar">
            <div class="bar-con">
              <van-field 
                label="用户号" 
                placeholder=""
                readonly
                clickable
                name="picker"
                :value="value"
                @click="showPicker = true"
              >
                <template #right-icon>
                  <span class="iconfont iconxuanzesanjiao"></span>
                </template>
              </van-field>
            </div>
          </div>
          <van-cell v-show="active===2||active===3" title="选择日期区间" :value="cDate" @click="cShow = true" />
          <van-calendar
            v-model="cShow"
            color="#1677FF"
            type="range"
            @confirm="cOnConfirm"
            :min-date="minDate"
            :max-date="maxDate"
            />
          <div class="comm-seperator"></div>
          <div v-show="active===0" class="main">
            <div v-if="userInfo" class="main-table">
              <van-row>
                <van-col span=6 class="main-col main-label">用户号</van-col>
                <van-col span=18 class="main-col main-right">{{userInfo.yhh}}</van-col>
              </van-row>
              <van-row>
                <van-col span=6 class="main-col main-label">户名</van-col>
                <van-col span=18 class="main-col main-right">{{userInfo.yhmc}}</van-col>
              </van-row>
              <van-row>
                <van-col span=6 class="main-col main-label">装表地址</van-col>
                <van-col span=18 class="main-col main-right">{{userInfo.zbwz}}</van-col>
              </van-row>
              <!-- <van-row>
                <van-col span=6 class="main-col main-label">用水类别</van-col>
                <van-col span=6 class="main-col">{{userInfo.ysxz}}</van-col>
                <van-col span=6 class="main-col main-label">用水状态</van-col>
                <van-col span=6 class="main-col main-right">{{userInfo.sbzt}}</van-col>
              </van-row> -->
              <van-row>
                <van-col span=6 class="main-col main-label">用水性质</van-col>
                <van-col span=6 class="main-col">{{userInfo.ysxz}}</van-col>
                <van-col span=6 class="main-col main-label">污水性质</van-col>
                <van-col span=6 class="main-col main-right">{{userInfo.wsxz}}</van-col>
              </van-row>
              <van-row>
                <van-col span=6 class="main-col2 main-label">表身号</van-col>
                <van-col span=6 class="main-col2">{{userInfo.bsh}}</van-col>
                <van-col span=6 class="main-col2 main-label">收费周期</van-col>
                <van-col span=6 class="main-col2 main-right">{{userInfo.sfzq}}</van-col>
              </van-row>
              <van-row>
                <van-col span=6 class="main-col2 main-label main-bottom">欠费金额</van-col>
                <van-col span=6 class="main-col2 main-bottom">{{userInfo.qfbs}}</van-col>
                <van-col span=12 class="main-col2 main-right main-bottom" style="border-left:0;">
                  <van-button
                    v-show="userInfo.qfbs&&userInfo.qfbs!=='0'"
                    type="info"
                    color="#1677FF"
                    size="small"
                    >
                    立即缴费
                  </van-button>
                </van-col>
              </van-row>
            </div>
          </div>
          <div v-show="active===1" class="main" style="padding: 18px 5px;">
            <div class="main-table" v-for="(item, i) in sewageList" :key="i" :style="{'margin-top': i===0?'0px':'10px'}">
              <van-row>
                <van-col span=6 class="main-col main-label">用户号</van-col>
                <van-col span=18 class="main-col main-right">{{item.rlcid}}</van-col>
              </van-row>
              <van-row>
                <van-col span=6 class="main-col main-label">户名</van-col>
                <van-col span=18 class="main-col main-right">{{item.rlcname}}</van-col>
              </van-row>
              <van-row>
                <van-col span=6 class="main-col main-label">应收月份</van-col>
                <van-col span=18 class="main-col main-right">{{item.rlmonth}}</van-col>
              </van-row>
              <van-row>
                <van-col span=6 class="main-col main-label">污水费计费水量</van-col>
                <van-col span=6 class="main-col">{{item.rlsl}}</van-col>
                <van-col span=6 class="main-col main-label">污水费单价</van-col>
                <van-col span=6 class="main-col main-right">{{item.rddj02}}</van-col>
              </van-row>
              <van-row>
                <van-col span=6 class="main-col2 main-label">污水费金额</van-col>
                <van-col span=6 class="main-col2">{{item.rdje02}}</van-col>
                <van-col span=6 class="main-col2 main-label">超浓度计费水量</van-col>
                <van-col span=6 class="main-col2 main-right">{{item.rdsl03}}</van-col>
              </van-row>
              <van-row>
                <van-col span=6 class="main-col main-label">cod值</van-col>
                <van-col span=6 class="main-col">{{item.codnd}}</van-col>
                <van-col span=6 class="main-col main-label">cod单价</van-col>
                <van-col span=6 class="main-col main-right">{{item.rddj04}}</van-col>
              </van-row>
              <van-row>
                <van-col span=6 class="main-col main-label">cod超浓度加价费</van-col>
                <van-col span=6 class="main-col">{{item.rdje04}}</van-col>
                <van-col span=6 class="main-col main-label">pH最小值</van-col>
                <van-col span=6 class="main-col main-right">{{item.phmin}}</van-col>
              </van-row>
              <van-row>
                <van-col span=6 class="main-col main-label">pH单价</van-col>
                <van-col span=6 class="main-col">{{item.rddj03}}</van-col>
                <van-col span=6 class="main-col main-label">pH加价费</van-col>
                <van-col span=6 class="main-col main-right">{{item.rdje03}}</van-col>
              </van-row>
              <van-row>
                <van-col span=6 class="main-col main-label">应收总金额</van-col>
                <van-col span=6 class="main-col">{{item.rlje}}</van-col>
                <van-col span=6 class="main-col main-label">欠费状态</van-col>
                <van-col span=6 class="main-col main-right">{{ztDitc[item.rlpaidflag]}}</van-col>
              </van-row>
              <van-row>
                <van-col span=6 class="main-col main-label main-bottom">应收流水号</van-col>
                <van-col span=6 class="main-col main-bottom">{{item.rlid}}</van-col>
                <van-col span=6 class="main-col main-label main-bottom">备注</van-col>
                <van-col span=6 class="main-col main-right main-bottom">{{item.rlmome}}</van-col>
              </van-row>
            </div>
          </div>
          <div v-show="active===2" class="main">
            <div v-if="cctList.length>0" class="main-table">
              <van-row>
                <van-col span=4 class="main-col main-label">用户号</van-col>
                <van-col span=4 class="main-col main-label">用水地址</van-col>
                <van-col span=4 class="main-col main-label">时间</van-col>
                <van-col span=4 class="main-col main-label">cod</van-col>
                <van-col span=4 class="main-col main-label">ph</van-col>
                <van-col span=4 class="main-col main-label main-right">ss</van-col>
              </van-row>
              <van-row v-for="(big, i) in cctList" :key="i">
                <van-col span=4 class="main-col2 main-bottom">{{big.userno}}</van-col>
                <van-col span=4 class="main-col2 main-bottom">{{big.fixaddr}}</van-col>
                <van-col span=4 class="main-col2 main-bottom">{{big.adddate}}</van-col>
                <van-col span=4 class="main-col2 main-bottom">{{big.cod}}</van-col>
                <van-col span=4 class="main-col2 main-bottom">{{big.ph}}</van-col>
                <van-col span=4 class="main-col2 main-bottom main-right">{{big.ss}}</van-col>
              </van-row>
            </div>
            <div v-if="cctList.length===0" style="text-align:center;">
              <img
                style="width:200px;"
                :src="require('../../assets/images/no-data.png')"
                >
            </div>
          </div>
          <div v-show="active===3" class="main">
            <div v-if="bigList.length>0" class="main-table">
              <van-row>
                <van-col span=6 class="main-col main-label">用户号</van-col>
                <van-col span=6 class="main-col main-label">站点名称</van-col>
                <van-col span=7 class="main-col main-label">时间</van-col>
                <van-col span=5 class="main-col main-label main-right">累计值</van-col>
              </van-row>
              <van-row v-for="(big, i) in bigList" :key="i">
                <van-col span=6 class="main-col2 main-bottom">{{big.userno}}</van-col>
                <van-col span=6 class="main-col2 main-bottom">{{big.station}}</van-col>
                <van-col span=7 class="main-col2 main-bottom">{{big.adddate}}</van-col>
                <van-col span=5 class="main-col2 main-bottom main-right">{{big.hours}}</van-col>
              </van-row>
            </div>
            <div v-if="bigList.length===0" style="text-align:center;">
              <img
                style="width:200px;"
                :src="require('../../assets/images/no-data.png')"
                >
            </div>
          </div>
          <div v-show="active===4" class="main">
            <div v-if="smallList.length===0" style="text-align:center;">
              <img
                style="width:200px;"
                :src="require('../../assets/images/no-data.png')"
                >
            </div>
            <div v-if="smallList.length>0" class="main-table">
              <van-row>
                <van-col span=4 class="main-col main-label">用户号</van-col>
                <van-col span=5 class="main-col main-label">用户名称</van-col>
                <van-col span=5 class="main-col main-label">时间</van-col>
                <van-col span=5 class="main-col main-label main-right">时流量</van-col>
                <van-col span=5 class="main-col main-label main-right">瞬时流量</van-col>
              </van-row>
              <van-row v-for="(small, i) in smallList" :key="i">
                <van-col span=4 class="main-col2 main-bottom">{{small.userno}}</van-col>
                <van-col span=5 class="main-col2 main-bottom">{{small.uname}}</van-col>
                <van-col span=5 class="main-col2 main-bottom">{{small.adddate}}</van-col>
                <van-col span=5 class="main-col2 main-bottom main-right">{{small.hours}}</van-col>
                <van-col span=5 class="main-col2 main-bottom main-right">{{small.moment}}</van-col>
              </van-row>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <van-popup v-model="show" style="width:92%;height:60%;border-radius:4px;">
      <div class="pop-table">
        <van-row>
          <van-col span=5 class="main-col main-label">日期</van-col>
          <van-col span=5 class="main-col main-label">本次抄见</van-col>
          <van-col span=4 class="main-col main-label">水量</van-col>
          <van-col span=5 class="main-col main-label">费用</van-col>
          <van-col span=5 class="main-col main-label main-right">状态</van-col>
        </van-row>
        <van-row>
          <van-col span=5 class="main-col">2020-02-18</van-col>
          <van-col span=5 class="main-col">93</van-col>
          <van-col span=4 class="main-col">10</van-col>
          <van-col span=5 class="main-col">27.50</van-col>
          <van-col span=5 class="main-col main-right">未到期</van-col>
        </van-row>
        <van-row>
          <van-col span=5 class="main-col main-label">2020-02-18</van-col>
          <van-col span=5 class="main-col main-label">93</van-col>
          <van-col span=4 class="main-col main-label">10</van-col>
          <van-col span=5 class="main-col main-label">27.50</van-col>
          <van-col span=5 class="main-col main-label main-right">未到期</van-col>
        </van-row>
        <van-row>
          <van-col span=5 class="main-col main-bottom">2019-11-18</van-col>
          <van-col span=5 class="main-col main-bottom">83</van-col>
          <van-col span=4 class="main-col main-bottom">18</van-col>
          <van-col span=5 class="main-col main-bottom">49.50</van-col>
          <van-col span=5 class="main-col main-bottom main-right" style="color:#2C82C9">已缴费</van-col>
        </van-row>
      </div>
    </van-popup>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
    <div style="height:57px;"></div>
    <home-bar></home-bar>
  </div>
</template>

<script>
import HomeBar from '@/components/HomeBar.vue'
export default {
  name: 'InfoQuery',
  components: {
    HomeBar
  },
  data() {
    return {
      ztDitc: {
        'Y': '已缴清',
        'N': '未缴'
      },
      show: false,
      checked:true,
      active: 0,
      tabs: [
        {
          title: '客户信息'
        },
        {
          title: '排污查询'
        },
        {
          title: '浓度查询'
        },
        {
          title: '大用户水量'
        },
        {
          title: '远传小表水量'
        }
      ],
      value: '',
      columns: ['杭州', '宁波', '温州', '嘉兴', '湖州'],
      showPicker: false,
      userInfo: {},
      useDetail: {},
      sewageList: [],
      cctList:[
        {
          "userno": "200000123", 
          "fixaddr": "绍兴学院",
          "adddate": "2020-03-01 12:34:23",
          "cod": "123",
          "ph": "3123",
          "ss": "3123"
        }
      ],
      bigList: [
        // {
        //   "userno": "200000123", 
        //   "station": "绍兴学院",
        //   "adddate": "2020-03-01 12:34:23",
        //   "moment": "123",
        //   "hours": "3123"
        // }
      ],
      smallList: [],
      userList: JSON.parse(localStorage.getItem('userList')),
      // eslint-disable-next-line no-undef
      cDate: moment().format('MM/DD') + '-' + moment().add(1, 'days').format('MM/DD'),
      cShow: false,
      // eslint-disable-next-line no-undef
      startDate: moment().format('YYYY-MM-DD'),
      // eslint-disable-next-line no-undef
      endDate: moment().add(1, 'days').format('YYYY-MM-DD'),
      // eslint-disable-next-line no-undef
      minDate: moment().subtract(7, 'days').toDate(),
      // eslint-disable-next-line no-undef
      maxDate: moment().add(7, 'days').toDate()
    }
  },
  mounted() {
    if (this.$route.query.active) {
      this.active = Number(this.$route.query.active)
    }

    let columns = []
    for(let i=0;i<this.userList.length;i++){
      columns.push(this.userList[i].userno)
    }
    this.columns = columns
    if(this.columns.length>0){
      this.value = this.columns[0]
      this.$comm.getUserInfo(this.value).then(res=>{
        this.userInfo = res
      })
    }
    this.onChange(this.active)
  },
  methods: {
    formatDate(date) {
      return `${date.getMonth() + 1}/${date.getDate()}`;
    },
    cOnConfirm(date) {
      const [start, end] = date;
      this.cShow = false;
      this.cDate = `${this.formatDate(start)} - ${this.formatDate(end)}`;
      // eslint-disable-next-line no-undef
      this.startDate = moment(start).format('YYYY-MM-DD');
      console.log("cOnConfirm -> this.startDate", this.startDate)
      // eslint-disable-next-line no-undef
      this.endDate = moment(end).format('YYYY-MM-DD');
      this.getBig()
    },
    getSewageFee(){
      this.$http.post(this.$api.getSewage, {
        userno: this.value,
      }).then(res => {
        if (res.code==='000') {
          this.sewageList = res.data
        } else {
          this.$toast(res.msg)
        }
      })
    },
    onChange (value){
      // eslint-disable-next-line no-debugger
      // debugger
      if(value===0){ // 客户信息
        this.$comm.getUserInfo(this.value).then(res=>{
          this.userInfo = res
        })
      } else if (value===1) { // 排污查询
        this.getSewageFee()
      } else if (value===2) { // 浓度查询
        this.getConcentration()
      } else if (value===3) { // 大用户
        this.getBig()
      } else{ // 远传小表
        this.getSmall()
      }
    },
    getConcentration(){
      this.cctList = []
      this.$http.post(this.$api.getConcentration, {
        userno: this.value,
        startdate: this.startDate,
        enddate: this.endDate
      }).then(res => {
        if (res.code==='000') {
          this.cctList = res.data?res.data:[]
        } else {
          this.$toast(res.msg)
        }
      })
    },
    getBig(){
      this.$http.post(this.$api.bigFee, {
        userno: this.value,
        startdate: this.startDate,
        enddate: this.endDate
      }).then(res => {
        if (res.code==='000') {
          this.bigList = res.data
        } else {
          this.$toast(res.msg)
        }
      })
    },
    getSmall(){
      this.$http.post(this.$api.smallFee, {
        userno: this.value
      }).then(res => {
        if (res.code==='000') {
          this.smallList = res.data
        } else {
          this.$toast(res.msg)
        }
      })
    },
    onConfirm(value) {
      this.value = value;
      this.showPicker = false;
      this.$comm.getUserInfo(this.value).then(res=>{
        this.userInfo = res
      })
    },
    btnClick () {
      this.getUseWater()
      this.show = true
    },
    getUseWater(){
      this.$http.post(this.$api.getUseWater, {
        userno: this.value
      }).then(res => {
        if (res.code==='000') {
          this.useDetail = res.data
        } else {
          this.$toast(res.msg)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.info-query{
  background:rgba(255,255,255,1);
  .tab-content{
    .main{
      background:rgba(255,255,255,1);
      padding: 18px 16px;
      .main-table{
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(33,33,33,1);
        .main-col{
          min-height:35px;
          border-left:1px solid rgba(214,216,214,1);
          border-top:1px solid rgba(214,216,214,1);
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0 10px;
        }
        .main-col2{
          min-height:60px;
          border-left:1px solid rgba(214,216,214,1);
          border-top:1px solid rgba(214,216,214,1);
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0 10px;
        }
        .main-label{
          background:rgba(240,246,241,1);
        }
        .main-right{
          border-right:1px solid rgba(214,216,214,1);
        }
        .main-bottom{
          border-bottom:1px solid rgba(214,216,214,1);
        }
      }
      .main-btn{
        margin-top:23px;
        height:44px;
        border-radius:4px;
      }
    }
  }
  .pop-table{
    font-size:12px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(33,33,33,1);
    padding: 15px 5px;
    .main-col{
      min-height:35px;
      border-left:1px solid rgba(214,216,214,1);
      border-top:1px solid rgba(214,216,214,1);
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 10px;
    }
    .main-label{
      background:rgba(240,246,241,1);
    }
    .main-right{
      border-right:1px solid rgba(214,216,214,1);
    }
    .main-bottom{
      border-bottom:1px solid rgba(214,216,214,1);
    }
  }
}
</style>